import template from './service_ticket_parts.html'
import controller from './service_ticket_parts.controller'
import './service_ticket_parts.scss'

const serviceTicketPartsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default serviceTicketPartsComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/service_ticket_parts.component.js